import PropTypes from "prop-types"
import { Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material"
import { ArrowBack } from "@mui/icons-material"
import TablePagination from "components/material/table-pagination"
import { formatLongDate } from "helpers/formatters/dates"

function CoverageReportSecurities({
  securities,
  securitiesPage,
  showSecuritiesPage,
  numberOfTableRows,
  coverageDate,
  resetDate,
  type,
}) {
  return <>
    <Table className="scan-preview-table coverage-securities-table">
      <TableHead>
        <TableRow className="pre-header">
          <TableCell className="date-back-button" onClick={resetDate}>
            <div className="date-back-button-wrapper">
              <ArrowBack /> {formatLongDate(coverageDate)}
            </div>
          </TableCell>
          <TableCell>Security in {type}</TableCell>
          <TableCell />
          <TableCell />
          <TableCell />
        </TableRow>
        <TableRow>
          <TableCell className="identifier">identifier</TableCell>
          <TableCell>from</TableCell>
          <TableCell>to</TableCell>
          <TableCell align="right">max % gmv</TableCell>
          <TableCell align="right">counts</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {securities.securities.map((security, i) =>
          <TableRow key={i}>
            <TableCell className="identifier">{security.ticker || security.sedol}</TableCell>
            <TableCell>{security.from}</TableCell>
            <TableCell>{security.to}</TableCell>
            <TableCell align="right">{security.maxGMV}</TableCell>
            <TableCell align="right">{security.counts}</TableCell>
          </TableRow>,
        )}
      </TableBody>
    </Table>
    <TablePagination
      rowsPerPageOptions={[]}
      component="div"
      count={securities.numberOfSecurities}
      rowsPerPage={numberOfTableRows}
      page={securitiesPage}
      onPageChange={showSecuritiesPage}
    />
  </>
}

CoverageReportSecurities.propTypes = {
  securities: PropTypes.object.isRequired,
  securitiesPage: PropTypes.number.isRequired,
  showSecuritiesPage: PropTypes.func.isRequired,
  numberOfTableRows: PropTypes.number.isRequired,
  coverageDate: PropTypes.string,
  resetDate: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
}

export default CoverageReportSecurities
